import styled from "styled-components";

export const BalanceInfoStyled = styled.main`
  p {
    color: #fff;
    font-size: 16px;
  }
`
